import { useRef, useState, useEffect } from 'react';

import { motion, useScroll, useTransform } from 'framer-motion';

import useGsapSection from '../../hooks/useGsapSection';

import { ScrambleReveal, ClipRevealText } from '../TextEffects';

import { SITE_VIDEOS } from '../../data/videos';

import './ReelSection.css';



const ReelSection = () => {

  const sectionRef = useRef(null);

  const videoRef = useRef(null);

  const inView = useGsapSection(sectionRef, { revealY: 24 });

  const [muted, setMuted] = useState(true);

  const [progress, setProgress] = useState(0);

  const [duration, setDuration] = useState(0);



  const { scrollYProgress } = useScroll({

    target: sectionRef,

    offset: ['start end', 'end start'],

  });

  const mediaScale = useTransform(scrollYProgress, [0, 1], [1.05, 1]);



  useEffect(() => {

    const v = videoRef.current;

    if (!v) return undefined;

    const onTime = () => {

      if (v.duration > 0) setProgress(v.currentTime / v.duration);

    };

    const onMeta = () => setDuration(v.duration || 0);

    v.addEventListener('timeupdate', onTime);

    v.addEventListener('loadedmetadata', onMeta);

    return () => {

      v.removeEventListener('timeupdate', onTime);

      v.removeEventListener('loadedmetadata', onMeta);

    };

  }, []);



  const fmt = (s) => {

    if (!s || Number.isNaN(s)) return '00:00';

    const m = Math.floor(s / 60).toString().padStart(2, '0');

    const sec = Math.floor(s % 60).toString().padStart(2, '0');

    return `${m}:${sec}`;

  };



  const toggleMute = () => {

    if (videoRef.current) {

      videoRef.current.muted = !videoRef.current.muted;

      setMuted(videoRef.current.muted);

    }

  };



  return (

    <section

      id="reel"

      ref={sectionRef}

      className="reel"

      data-testid="reel-section"

    >

      <div className="reel-strip">

        <span className="reel-strip-left gsap-reveal">

          <span className="reel-strip-num">(002)</span>

          <span className="reel-strip-divider" />

          <ClipRevealText text="Reel" delay={0.05} externalInView={inView} />

          {' '}

          <ScrambleReveal text="— Selected Motion / 2026" delay={0.15} externalInView={inView} />

        </span>

        <span className="reel-strip-right tabular gsap-reveal">

          {fmt(progress * duration)} / {fmt(duration)}

        </span>

      </div>



      <div className="reel-frame gsap-reveal">

        <motion.div className="reel-media" style={{ scale: mediaScale }}>

          <video

            ref={videoRef}

            className="reel-video"

            autoPlay

            loop

            muted={muted}

            playsInline

            preload="metadata"

            data-testid="reel-video"

          >

            <source

              src={SITE_VIDEOS.homeReel}

              type="video/mp4"

            />

          </video>

          <div className="reel-vignette" aria-hidden="true" />



          <button

            className="reel-mute"

            onClick={toggleMute}

            aria-label={muted ? 'Unmute reel' : 'Mute reel'}

            data-testid="reel-mute-toggle"

          >

            <span className="reel-mute-dot" data-active={!muted} aria-hidden="true" />

            <span>{muted ? 'Sound off — click to play audio' : 'Sound on — click to mute'}</span>

          </button>



          <div className="reel-bar" aria-hidden="true">

            <motion.div className="reel-bar-fill" style={{ scaleX: progress }} />

          </div>

        </motion.div>

      </div>



      <div className="reel-caption">

        <span className="reel-caption-left gsap-reveal">

          A composite of selected motion work. Case studies on request.

        </span>

        <span className="reel-caption-right gsap-reveal">

          <ScrambleReveal text="16:9 · 1080p · Loop" delay={0.2} externalInView={inView} />

        </span>

      </div>

    </section>

  );

};



export default ReelSection;

